import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { GLOBAL_CONSTANTS, ROUTES, TOASTER_CONFIGS } from '../../constants';
import { Button, TextField, Box, Grid, Typography, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDepartmentDropdownListQuery, useEmployeeCreateMutation, useEmployeeGetOneQuery, useEmployeeUpdateMutation } from '../../service/apiSlices/accessApiService';


const CreateEmployee = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const { data: getData } = useEmployeeGetOneQuery(id);
    const { data: DeparmentList } = useDepartmentDropdownListQuery('');

    const [initialValues, setInitialValues] = useState({
        firstname: '',
        lastname: '',
        email: '',
        employee_id: '',
        emirates_id: '',
        department_id: '',
    });
    const [createApiCall] = useEmployeeCreateMutation();
    const [updateApiCall] = useEmployeeUpdateMutation();

    useEffect(() => {
        var Response = getData?.result?.data[0]
        if (getData?.result?.data) {
            setInitialValues({
                firstname: Response.firstname,
                lastname: Response.lastname,
                email: Response.email,
                employee_id: Response.employee_id,
                emirates_id: Response.emirates_id,
                department_id: Response.department,
            })
        }
    }, [getData])

    const validationSchema = Yup.object({
        firstname: Yup.string()
            .max(50, 'Must be 50 characters or less')
            .required('Required'),
        lastname: Yup.string()
            .max(50, 'Must be 50 characters or less')
            .required('Required'),
        email: Yup.string()
            .email('Invalid email address')
            .required('Required'),
        employee_id: Yup.string()
            .matches(/^[A-Za-z0-9]+$/, 'Must be alphanumeric')
            .required('Required'),
        emirates_id: Yup.string()
            .matches(/^[A-Za-z0-9]+$/, 'Must be alphanumeric')
            .required('Required')
            .length(15, 'Must be exactly 15 characters'),
        department_id: Yup.string()
            .matches(/^[A-Za-z0-9]+$/, 'Must be alphanumeric')
            .required('Required'),
    });

    const EditvalidationSchema = Yup.object({
        email: Yup.string()
            .email('Invalid email address')
            .required('Required'),
        employee_id: Yup.string()
            .matches(/^[A-Za-z0-9]+$/, 'Must be alphanumeric')
            .required('Required'),
        emirates_id: Yup.string()
            .matches(/^[A-Za-z0-9]+$/, 'Must be alphanumeric')
            .required('Required')
            .length(15, 'Must be exactly 15 characters'),
        department_id: Yup.string()
            .matches(/^[A-Za-z0-9]+$/, 'Must be alphanumeric')
            .required('Required'),
    });

    const handleApicall = (values: any) => {

        if (id && getData) {
            var updatePayload = {
                id: id,
                firstname: values.firstname,
                lastname: values.lastname,
                email: values.email,
                employee_id: values.employee_id,
                emirates_id: values.emirates_id,
                department_id: values.department_id,
            }
            updateApiCall(updatePayload)
                .unwrap()
                .then((response) => {
                    toast.success(response?.message, TOASTER_CONFIGS);
                    navigate(ROUTES.MANAGEEMPLOYEE);
                })
                .catch((error) => {
                    toast.error(error?.data?.message, TOASTER_CONFIGS);
                })
        } else {

            var createPayload = {
                firstname: values.firstname,
                lastname: values.lastname,
                email: values.email,
                employee_id: values.employee_id,
                emirates_id: values.emirates_id,
                department_id: values.department_id,
                roles_id: 3,
            }
            createApiCall(createPayload)
                .unwrap()
                .then((response) => {
                    toast.success(response?.message, TOASTER_CONFIGS);
                    navigate(ROUTES.MANAGEEMPLOYEE);
                })
                .catch((error) => {
                    toast.error(error?.data?.message, TOASTER_CONFIGS);
                })
        }
    };

    return (
        <>

            <Formik
                initialValues={initialValues}
                validationSchema={id && getData ? EditvalidationSchema : validationSchema}
                onSubmit={(values, actions) => {
                    handleApicall(values);
                }}
                enableReinitialize={true}
            >
                {(formik) => (
                    <Box
                        component="form"
                        sx={{ '& .MuiTextField-root': { m: 1, width: '100%' } }}
                        noValidate
                        autoComplete="off"
                        onSubmit={formik.handleSubmit}
                    >
                        <Grid container spacing={2} justifyContent="flex-start" alignContent='center' marginTop={1} marginBottom={3}
                            sx={{ cursor: 'pointer' }} onClick={() => navigate(-1)}>
                            <KeyboardArrowLeftIcon />
                            <Typography>
                                {id ? 'Edit' : 'Add'} Employee
                            </Typography>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    id="outlined-controlled"
                                    label="First Name"
                                    name="firstname"
                                    disabled={id ? true : false}
                                    value={formik.values.firstname}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.firstname && Boolean(formik.errors.firstname)}
                                    helperText={formik.touched.firstname && formik.errors.firstname}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    id="outlined-controlled"
                                    label="Last Name"
                                    name="lastname"
                                    disabled={id ? true : false}
                                    value={formik.values.lastname}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.lastname && Boolean(formik.errors.lastname)}
                                    helperText={formik.touched.lastname && formik.errors.lastname}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    id="outlined-controlled"
                                    label="Email"
                                    name="email"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email && formik.errors.email}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    id="outlined-controlled"
                                    label="Employee_id"
                                    name="employee_id"
                                    value={formik.values.employee_id}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.employee_id && Boolean(formik.errors.employee_id)}
                                    helperText={formik.touched.employee_id && formik.errors.employee_id}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    id="outlined-controlled"
                                    label="Emirates_id"
                                    name="emirates_id"
                                    value={formik.values.emirates_id}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.emirates_id && Boolean(formik.errors.emirates_id)}
                                    helperText={formik.touched.emirates_id && formik.errors.emirates_id}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth sx={{ mt: 1, ml: 1 }}>
                                    <InputLabel id="demo-simple-select-label">Category</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        name="department_id"
                                        value={formik.values.department_id}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.department_id && Boolean(formik.errors.department_id)}
                                        label="Category"
                                    >
                                        {DeparmentList?.result?.data.length > 0 &&
                                            DeparmentList?.result?.data?.map((item: any, i: any) => {
                                                return (
                                                    <MenuItem key={i} value={item?.id}>{item?.name}</MenuItem>
                                                )

                                            })}
                                    </Select>
                                    {formik.touched.department_id && formik.errors.department_id ? (
                                        <FormHelperText sx={{ color: '#d32f2f' }} >{formik.errors.department_id}</FormHelperText>
                                    ) : null}
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} justifyContent="flex-end">
                            <Grid item>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        if (id && getData) {
                                            var Response = getData?.result?.data[0]
                                            if (getData?.result?.data) {
                                                setInitialValues({
                                                    firstname: Response.firstname,
                                                    lastname: Response.lastname,
                                                    email: Response.email,
                                                    employee_id: Response.employee_id,
                                                    emirates_id: Response.emirates_id,
                                                    department_id: Response.department,
                                                })
                                            }
                                        } else {
                                            formik.resetForm();
                                        }
                                    }}
                                    sx={{ mt: 3, mb: 2 }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 3, mb: 2, background: `${GLOBAL_CONSTANTS.COLOR_CODE.GRADIENT}` }}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                )}
            </Formik>

        </>
    )
}

export default CreateEmployee;